import {
  Box,
  LinearProgress,
  Paper,
  Typography,
  Container,
  Button,
} from "@mui/material";
import { useEffect, useState } from "react";
import useFetchDataWithPagination from "../../../utility/useFetchDataWithPagination";
import CardDeclaration from "../Declaration/CardDeclaration";

const MeDeclarationComponent = () => {
  const { data, isLoading, paginate, refreshSearch } =
    useFetchDataWithPagination("online_declaration_detaches");
  const [declarations, setDeclaration] = useState(null);

  useEffect(() => {
    if (data?.data) {
      setDeclaration(data.data.data);
    }
    return () => {
      setDeclaration(null);
    };
  }, [data]);

  const formatDateToFrench = (date) => {
    return new Date(date).toLocaleDateString("fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <Container>
      <Box sx={{ m: 1, width: "95%", margin: "auto", mt: 3 }}>
        <Paper elevation={2} sx={{ p: 3 }}>
          {isLoading && (
            <LinearProgress
              sx={{
                backgroundColor: "#e0e0e0",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#00a652",
                },
              }}
            />
          )}

          <Typography
            variant="h5"
            component="h1"
            sx={{
              color: "#00a652",
              fontWeight: 500,
              mb: 3,
            }}
          >
            Mes déclarations
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {declarations && declarations.length > 0 ? (
              declarations.map((declaration, index) => (
                <Box key={index}>
                  <CardDeclaration
                    declaration={{
                      ...declaration,
                      created_at: formatDateToFrench(declaration.created_at),
                    }}
                    refreshSearch={refreshSearch}
                  />

                  {index !== declarations.length - 1 && (
                    <hr style={{ margin: "1rem 0", opacity: 0.2 }} />
                  )}
                </Box>
              ))
            ) : (
              <Typography
                variant="body1"
                sx={{
                  textAlign: "center",
                  color: "#666",
                  py: 4,
                }}
              >
                Aucune déclaration disponible
              </Typography>
            )}
          </Box>

          {declarations && declarations.length > 8 && (
            <Box sx={{ mt: 3 }}>{paginate()}</Box>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default MeDeclarationComponent;
